// extracted by mini-css-extract-plugin
export default {"update-offer-modal":"styles__update-offer-modal--DISu5","modal-title":"styles__modal-title--cV9XG","header-container":"styles__header-container--HP5mc"};